class Contact {
  constructor () {
    this.validationForm();
    this.heightBlocks();
    window.addEventListener('resize',this.heightBlocks)
  }
  validationForm () {
    $(window).on('load',function(){
      $(".contact-form").validationEngine({
        promptPosition: 'topLeft',
        scroll: false
      });
    });
  }
  heightBlocks () {
      if(window.outerWidth > 980) {
        waitForElementToDisplay('textarea#edit-message, #block-mapsblock', 2, 100, function () {
          document.querySelector('#block-mapsblock').style.height = setHeight() + 'px';
        })
      }
      else{
        document.querySelector('#block-mapsblock').style.height = '';
      }
  }
}

function waitForElementToDisplay(selector, number, time, cb) {
  let elements = document.querySelectorAll(selector)
  if (elements.length === number) {
    cb();
  }
  else {
    setTimeout(function() {
      waitForElementToDisplay(selector, number, time, cb);
    }, time);
  }
}

function setHeight () {
  let textArea = document.querySelector('textarea#edit-message');
  let maps = document.querySelector('#block-mapsblock');
  let bottomText = parseInt(textArea.getBoundingClientRect().top + textArea.offsetHeight, 10);
  let bottomRight = parseInt(maps.getBoundingClientRect().top + maps.offsetHeight, 10);
  if (bottomText > bottomRight) {
    return maps.offsetHeight + (bottomText - bottomRight);
  } else if (bottomText < bottomRight) {
    return maps.offsetHeight - (bottomRight - bottomText);
  }
}

export default Contact;